import styled from '../node_modules/.pnpm/@linaria_react@3.0.0-beta.15_react@17.0.2/node_modules/@linaria/react/esm/styled.js';
import { getPresets } from '@indriver/vandermeer';
import { variables } from '@indriver/yrel';
import preset, { prefixContainerPreset } from './preset.js';

var style = getPresets(preset, {
  background: 'design',
  mainColor: 'design',
  minHeight: 'size',
  minHeightWithSecondary: 'size',
  topPadding: 'size',
  bottomPadding: 'size',
  topPaddingWithoutSecondary: 'size',
  bottomPaddingWithoutSecondary: 'size',
  rightPadding: 'appendixState',
  leftPadding: 'appendixState',
  topPaddingLoading: 'size',
  topPaddingLoadingWithoutSecondary: 'size',
  bottomPaddingLoading: 'size',
  bottomPaddingLoadingWithoutSecondary: 'size'
});
var prefixStyle = getPresets(prefixContainerPreset, {
  paddingTop: 'size',
  paddingTopWithSecondary: 'size',
  paddingRight: 'size',
  iconSize: 'size',
  paddingTopLoading: 'size'
});

var getMinHeight = function getMinHeight(props) {
  if (props.secondaryState === 'with-secondary') {
    return style.minHeightWithSecondary(props);
  }

  return style.minHeight(props);
};

var getTopPadding = function getTopPadding(props) {
  if (props.secondaryState === 'with-secondary') {
    return props.loadingView ? style.topPaddingLoading(props) : style.topPadding(props);
  }

  return props.loadingView ? style.topPaddingLoadingWithoutSecondary(props) : style.topPaddingWithoutSecondary(props);
};

var getBottomPadding = function getBottomPadding(props) {
  if (props.secondaryState === 'with-secondary') {
    return props.loadingView ? style.bottomPaddingLoading(props) : style.bottomPadding(props);
  }

  return props.loadingView ? style.bottomPaddingLoadingWithoutSecondary(props) : style.bottomPaddingWithoutSecondary(props);
};

var getCellCursor = function getCellCursor(props) {
  if (props.loadingView) {
    return 'progress';
  }

  if (props.disabledView) {
    return style.disabledCursor();
  }

  return 'pointer';
};

var getCellBackground = function getCellBackground(props) {
  var disabledView = props.disabledView,
      focused = props.focused;

  if (disabledView) {
    return style.disabledBackground(props);
  }

  if (focused) {
    return variables['statement-background-primarypressed'];
  }

  return style.background(props);
};

var getCellBorder = function getCellBorder(_ref) {
  var focused = _ref.focused;
  return focused ? style.focusedBorderColor() : 'transparent';
};

var Box = /*#__PURE__*/styled("div")({
  name: "Box",
  class: "bosxe5g",
  vars: {
    "bosxe5g-0": [getCellBackground],
    "bosxe5g-1": [function (props) {
      return props.disabledView ? style.disabledColor() : style.mainColor(props);
    }],
    "bosxe5g-2": [getCellBorder],
    "bosxe5g-4": [getCellCursor],
    "bosxe5g-5": [function (_ref2) {
      var disabledView = _ref2.disabledView,
          loadingView = _ref2.loadingView;
      return disabledView || loadingView ? 'none' : 'auto';
    }],
    "bosxe5g-7": [style.focusedBorderColor]
  }
});
var ContentContainer = /*#__PURE__*/styled("div")({
  name: "ContentContainer",
  class: "c1dnsfnd",
  vars: {
    "c1dnsfnd-0": [getTopPadding],
    "c1dnsfnd-1": [getBottomPadding],
    "c1dnsfnd-2": [function (props) {
      return props.dir === 'ltr' ? style.leftPadding(props) : style.rightPadding(props);
    }],
    "c1dnsfnd-3": [function (props) {
      return props.dir === 'ltr' ? style.rightPadding(props) : style.leftPadding(props);
    }],
    "c1dnsfnd-4": [getMinHeight]
  }
});
var ContentContainerLoading = /*#__PURE__*/styled(ContentContainer)({
  name: "ContentContainerLoading",
  class: "c1djh9am"
});

var getPrefixPaddingTop = function getPrefixPaddingTop(props) {
  if (props.secondaryState === 'none') {
    return props.loadingView ? prefixStyle.paddingTopLoading(props) : prefixStyle.paddingTop(props);
  }

  return prefixStyle.paddingTopWithSecondary(props);
};

var PrefixContainer = /*#__PURE__*/styled("div")({
  name: "PrefixContainer",
  class: "pr41qc",
  vars: {
    "pr41qc-0": [getPrefixPaddingTop],
    "pr41qc-2": [function (props) {
      return props.dir === 'ltr' ? prefixStyle.paddingRight(props) : prefixStyle.paddingLeft(props);
    }],
    "pr41qc-3": [function (props) {
      return props.dir === 'ltr' ? prefixStyle.paddingLeft(props) : prefixStyle.paddingRight(props);
    }]
  }
});
var IconContainer = /*#__PURE__*/styled("div")({
  name: "IconContainer",
  class: "iw6p0ri",
  vars: {
    "iw6p0ri-0": [prefixStyle.iconSize]
  }
});

export { Box, ContentContainer, ContentContainerLoading, IconContainer, PrefixContainer };


require('../../styles-linaria/cell/cell.styles.css');
